import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=2d67ba8d&scoped=true"
import script from "./TransactionsList.vue?vue&type=script&lang=js"
export * from "./TransactionsList.vue?vue&type=script&lang=js"
import style0 from "./TransactionsList.vue?vue&type=style&index=0&id=2d67ba8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d67ba8d",
  null
  
)

export default component.exports